import React from 'react';
import { Drawer, IconButton, Link, Box } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import DrawerHeader from './DrawerHeader';
import MenuList from './MenuList';
import DrawerUserInfoContainer from '../../../containers/common/header/DrawerUserInfoContainer';

import { Link as RouterLink } from 'react-router-dom';

const LeftDrawer = ({ drawerWidth, open, handleDrawerClose, isMobile }) => {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          zIndex: (theme) => isMobile ? theme.zIndex.drawer + 100 : theme.zIndex.drawer,
        },

      }}
      variant={isMobile ? "temporary" : "persistent"}
      anchor="left"
      open={open}
      onClose={handleDrawerClose}
      ModalProps={{
        keepMounted: true, // 모바일 성능 최적화
        disableScrollLock: true, // [해결] 검은 화면/페이지 튀는 현상 방지
      }}
    // PaperProps={{
    //   sx: {
    //     backgroundColor: "#37474f",
    //     color: "#eceff1",
    //   }
    // }}
    >
      <DrawerHeader sx={{ backgroundColor: '#fafafa' }}>
        <Box sx={{ px: 1 }}>
          <Link component={RouterLink} to="/">
            <img src="/static/images/logo/logo.svg" alt="hcinfo" style={{ width: 140, height: 32, transform: 'scale(0.9)' }} />
          </Link>
        </Box>
        <IconButton onClick={handleDrawerClose} sx={{ color: '#37474f' }}>
          <MenuOpenIcon />
        </IconButton>
      </DrawerHeader>

      <DrawerUserInfoContainer />

      <MenuList handleDrawerClose={isMobile ? handleDrawerClose : undefined}  />
    </Drawer>
  )
}

export default LeftDrawer